<template>
  <div v-if="ready" class="user">
    <v-card elevation="4" class="mb-4" :color="isThemeAja ? '#4E983C' : 'primary'" :class="{'theme-aja-active': isThemeAja}">
      <v-card-text>
        <!-- Header Section -->
        <v-row align="center" class="headline" no-gutters>
          <v-col cols="auto">
            <v-icon x-large class="white--text mr-5">account_circle</v-icon>
          </v-col>
          <v-col>
            <div class="font-weight-bold white--text text-no-wrap">Mes coordonnées</div>
            <p class="subtitle-1 mb-0 white--text">Gérez vos informations personnelles</p>
          </v-col>
          <v-col cols="auto">
            <v-btn
              v-if="user.id === $store.getters.getProfile.id"
              :color="isThemeAja ? '#294D5B' : color"
              :to="{ name: 'profile-edit' }"
              class="mr-2 elevation-0"
              fab
            >
              <v-icon>edit</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-card elevation="4" class="mb-4" :color="isThemeAja ? '#1E3945' : ''" :class="{'theme-aja-active': isThemeAja}">
      <v-card-text>
        <!-- Personal Information Section -->
        <v-row>
          <v-col>
            <h3>Informations personnelles</h3>
            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-title>Nom</v-list-item-title>
                <v-list-item-subtitle>{{ value.lastname }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-title>Prénom</v-list-item-title>
                <v-list-item-subtitle>{{ value.firstname }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-title>Email</v-list-item-title>
                <v-list-item-subtitle>
                  <a
                    :style="{ color: isThemeAja ? 'white' : '' }"
                    :href="`mailto:${value.email}`"
                  >{{ value.email }}</a>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-list-item v-if="value.role" two-line>
              <v-list-item-content>
                <v-list-item-title>Abonnement en cours</v-list-item-title>
                <v-list-item-subtitle>
                  <template v-if="user.premium_dates">
                    {{ formatDate(user.premium_dates.start) }} - {{ formatDate(user.premium_dates.end) }}
                  </template>
                  <template v-else>Aucun</template>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-col>

          <v-col>
            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-title>Date de naissance</v-list-item-title>
                <v-list-item-subtitle>{{ formatDate(value.birthdate) }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-title>Adresse</v-list-item-title>
                <v-list-item-subtitle>
                  {{ value.street }}<br>
                  {{ value.zip }} {{ value.city }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-title>Téléphone</v-list-item-title>
                <v-list-item-subtitle>
                  <a
                    :style="{ color: isThemeAja ? 'white' : '' }"
                    :href="`tel:${value.phone}`"
                  >{{ value.phone }}</a>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-col>
        </v-row>

        <!-- PAP Assistant Section -->
        <v-row v-if="value.aja_role === 'aja_young'">
          <v-col cols="12">
            <h3>Mon aidant PAP</h3>
          </v-col>
          <template v-if="value.aja_assistant">
            <v-col>
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title>Nom</v-list-item-title>
                  <v-list-item-subtitle>{{ value.aja_assistant.lastname }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title>Email</v-list-item-title>
                  <v-list-item-subtitle>{{ value.aja_assistant.email }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col>
                <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title>Prénom</v-list-item-title>
                  <v-list-item-subtitle>{{ value.aja_assistant.firstname }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>
          </template>
          <v-col v-else>
            <p>Aucun aidant PAP</p>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'UserDetails',
  
  props: {
    value: {
      type: Object,
      required: true,
      validator: (value) => {
        return value && typeof value === 'object'
      }
    },
    color: {
      type: String,
      default: 'primary'
    }
  },

  data() {
    return {
      ready: false,
      user: {}
    }
  },

  computed: {
    ...mapGetters(['isThemeAja'])
  },

  mounted() {
    this.initializeUser()
  },

  methods: {
    initializeUser() {
      this.user = { ...this.value }
      this.ready = true
    },

    formatDate(date) {
      return this.$moment(date).format('DD/MM/YYYY')
    }
  }
}
</script>
